import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Sortable from 'sortablejs';

export default class Sort extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    this.App.Events.subscribe('sortable.refresh', () => {
      this.start();
    });

    this.App.Events.subscribe('storage.refresh', () => {
      this.start();
    });
  }

  start() {

    $('.is-sortable').each(function() {

      new Sortable($(this).get(0), {
        sort: true,
        animation: 150,
        swapThreshold: 0.90,
        direction: 'horizontal'
      });

    });

  }

}